package com.eladfinish.bible.contest.screens.browse.usecases.shonot

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.parashat_haman_ending
import com.eladfinish.bible.contest.parashat_haman_intro
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentUseCase
import com.eladfinish.bible.contest.utils.beautifyText
import dev.icerock.moko.resources.desc.desc

class GetParashatHaManContentUseCase(
    private val getContentUseCase: GetContentUseCase,
    private val stringResolver: StringResolver,
) {
    operator fun invoke(): String {
        val content = getContentUseCase.getContent(
            bookIndex = 2,
            bookName = "shemot",
            currentChapter = 16,
            startVerseReferenceCV = VerseReferenceCV(chapter = 16, verse = 4),
            endVerseReferenceCV = VerseReferenceCV(chapter = 16, verse = 36),
            onlyQri = true,
        ).beautifyText()

        return buildString {
            append(stringResolver.resolveString(SharedRes.strings.parashat_haman_intro.desc()))
            append("\n\n")
            append(content)
            append("\n\n")
            append(stringResolver.resolveString(SharedRes.strings.parashat_haman_ending.desc()))
        }
    }
}
